"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CXTupleI18nDomainMappingV2ClientImpl_1 = __importDefault(require("./CXTupleI18nDomainMappingV2ClientImpl"));
var CXTupleI18nDomainMappingV2ClientProvider = /** @class */ (function () {
    function CXTupleI18nDomainMappingV2ClientProvider() {
        this.CONTEXTUAL_PARAMETERS = ["i18n_cx_family", "i18n_cx_id", "i18n_cx_program"];
        this.STAGE_VERSION_LABEL_NAME = "AcsCXTupleI18nDomainMappingV2";
        this.TABLE_NAME = "acs_CXTupleI18nDomainMappingV2";
    }
    CXTupleI18nDomainMappingV2ClientProvider.prototype.createTypeSafeClient = function (configSet) {
        return new CXTupleI18nDomainMappingV2ClientImpl_1.default(configSet);
    };
    return CXTupleI18nDomainMappingV2ClientProvider;
}());
exports.default = CXTupleI18nDomainMappingV2ClientProvider;
